import { Box } from '@mui/material';
import { EnumDropdown, WysiwygInput } from 'framework/form';
import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import type { CreateEditFormSection } from 'framework/ViewTypes/contentLayout';

type ApplicationInterviewResultsDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

const RECOMMENDATIONS = {
  CONTINUE_EVALUATION: 'Continue evaluation',
  REJECT_CANDIDATE: 'Reject candidate',
};

const FULL_ROW_SIZE = { xs: 12, md: 12, xl: 12 };

const PROVIDE_RESULTS_SECTIONS: CreateEditFormSection[] = [
  {
    id: 'feedback',
    title: 'Feedback *',
    fields: [
      {
        id: 'feedback',
        size: FULL_ROW_SIZE,
        content: <WysiwygInput source="feedback" label="" isRequired />,
      },
    ],
  },
  {
    id: 'recommendation',
    fields: [
      {
        id: 'recommendation',
        size: FULL_ROW_SIZE,
        content: (
          <Box sx={{ maxWidth: 260 }}>
            <EnumDropdown source="recommendation" label="Recommendation" options={RECOMMENDATIONS} isRequired />
          </Box>
        ),
      },
    ],
  },
];

const ApplicationInterviewResultsDrawer = ({ isOpen, onClose }: ApplicationInterviewResultsDrawerProps) => (
  <CreateEditFormDrawer
    isOpen={isOpen}
    onClose={onClose}
    title={'Provide screening interview results'}
    isCreateRequest
    submitFormFunc={async () => {}}
    afterSubmit={{ execute: onClose, message: 'Interview results saved.' }}
    submitButtonTitle="Submit"
    handleDirty={false}
    getSections={() => PROVIDE_RESULTS_SECTIONS}
  />
);

export default ApplicationInterviewResultsDrawer;
